<sd-modal data-analytics="delivery_calc_modal">
  <div class="cx-dialog-header modal-header">
    <h2>Ваша доставка</h2>
  </div>
  <div class="cx-dialog-body modal-body">
    <ng-container *ngIf="{ deliverySlots: deliverySlots$ | async, loading: loading$ | async } as observables">
      <ng-container *ngIf="!observables.loading; else skeleton">
        <div #skeleton></div>
        <ng-container *ngIf="observables.deliverySlots?.length; else emptyResult">
          <p>Данный расчет не учитывает текущее время, актуальные данные можно увидеть при оформлении заказа</p>
          <div class="slots">
            <ng-container *ngFor="let deliverySlot of observables.deliverySlots; let dnd = index">
              <div *ngIf="deliverySlot" class="slot">
                <div class="slot-title">
                  <strong *ngIf="dnd === 0">Сегодня</strong>
                  <strong *ngIf="dnd > 0">Завтра и позже</strong>
                  <span class="prices">
                    от {{ deliverySlot.slots[0].price }} ₽ до
                    {{ deliverySlot.slots[deliverySlot.slots.length - 1].price }} ₽
                  </span>
                </div>

                <sd-radio
                  *ngFor="let slot of deliverySlot.slots; let indexSlot = index"
                  name="deliverySlot"
                  [formControl]="formSlot"
                  [value]="getSlotId(dnd, indexSlot)"
                  class="description"
                >
                  {{ slot.intervalDescription }},
                  <ng-container *ngTemplateOutlet="orderPrice; context: { orderPrice: slot.orderPrice }"></ng-container>
                  -
                  {{ slot.price }} ₽
                </sd-radio>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <div class="weight-field" [formGroup]="deliveryCalculatorFormService.form">
          <sd-form-field label="Вес заказа кг">
            <input
              class="field-weight"
              type="number"
              sdOnlyNumber="float"
              [formControl]="deliveryCalculatorFormService.weight"
              [value]="deliveryCalculatorFormService.weight.value"
            />
          </sd-form-field>
        </div>
      </ng-container>
      <ng-container *ngIf="{ price: currentPrice$ | async } as currentPrice">
        <div *ngIf="currentPrice.price !== null && currentPrice.price !== undefined">
          <div *ngIf="!observables.loading" class="total-wrapper row">
            <div class="col-6"></div>
            <div class="col-6 text-right total">
              Итого:
              <span>от {{ currentPrice.price }} ₽</span>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #emptyResult>
      Менеджер уточнит подходящие правила доставки. Либо попробуйте изменить вес или адрес
    </ng-template>
  </div>
</sd-modal>

<ng-template #orderPrice let-orderPrice="orderPrice">
  <ng-container *ngIf="orderPrice[0] === 0 && orderPrice[1] >= 99999999">при любой сумме заказа</ng-container>
  <ng-container *ngIf="orderPrice[0] > 0 && orderPrice[1] >= 99999999">
    при сумме заказа от {{ orderPrice[0] }} ₽
  </ng-container>
  <ng-container *ngIf="orderPrice[0] === 0 && orderPrice[1] < 99999999">
    при сумме заказа до {{ orderPrice[1] }} ₽
  </ng-container>
  <ng-container *ngIf="orderPrice[0] > 0 && orderPrice[1] < 99999999">
    при сумме заказа от {{ orderPrice[0] }} ₽ до {{ orderPrice[1] }} ₽
  </ng-container>
</ng-template>

<ng-template #skeleton>
  <div class="information">Расчёт стоимости доставки...</div>
  <div class="results-loading-skeleton-container">
    <div class="skeleton-wrapper">
      <div class="date"></div>
    </div>
    <div class="skeleton-wrapper">
      <div class="options"></div>
    </div>
    <div class="skeleton-wrapper">
      <div class="options"></div>
    </div>
    <div class="skeleton-wrapper">
      <div class="date"></div>
    </div>
    <div class="skeleton-wrapper">
      <div class="options"></div>
    </div>
    <div class="skeleton-wrapper">
      <div class="weight"></div>
    </div>
    <div class="total-wrapper row">
      <div class="col-6"></div>
      <div class="col-6">
        <div class="current-price-skeleton-container">
          <span class="current-price-skeleton-text">Итого:</span>
          <span class="current-price-skeleton"></span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
